/*  ========================================================================
    # Components - Paginated Slider
    ========================================================================  */
import React from 'react';
import PropTypes from 'prop-types';
import { motion, MotionConfig, useReducedMotion } from 'motion/react';
import useLocalization from '../hooks/useLocalization';

const PaginatedSlider = ({
  index,
  count,
  infinite = false,
  onBack,
  onNext,
  nextLabel,
  backLabel
}) => {
  const locale = useLocalization();
  const reduced = useReducedMotion();
  return (
    <MotionConfig reducedMotion='user'>
      <div className='c-universal-slider'>
        <div className='c-universal-slider__indicator-wrapper' aria-hidden>
          <motion.div
            className='c-universal-slider__indicator'
            initial={false}
            animate={{
              left: `${(index / count) * 100}%`,
              right: `${((count - index - 1) / count) * 100}%`
            }}
            transition={
              reduced
                ? {
                    duration: 0
                  }
                : {
                    visualDuration: 0.5
                  }
            }
          />
        </div>
        <motion.button
          onClick={onBack}
          className='c-universal-slider__button'
          disabled={!infinite && index <= 0}
          title={backLabel}
          whileTap={{ scale: 0.9 }}
        >
          <span className='u-screenreader'>{backLabel}</span>
          <svg viewBox='0 0 50 50' aria-hidden>
            <use href={`${locale('svgSprite')}#arrow-left-big`} />
          </svg>
        </motion.button>
        <motion.button
          onClick={onNext}
          className='c-universal-slider__button'
          disabled={!infinite && index >= count - 1}
          title={nextLabel}
          whileTap={{ scale: 0.9 }}
        >
          <span className='u-screenreader'>{nextLabel}</span>
          <svg viewBox='0 0 50 50' aria-hidden>
            <use href={`${locale('svgSprite')}#arrow-right-big`} />
          </svg>
        </motion.button>
      </div>
    </MotionConfig>
  );
};

PaginatedSlider.propTypes = {
  index: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  infinite: PropTypes.bool,
  nextLabel: PropTypes.string.isRequired,
  backLabel: PropTypes.string.isRequired
};

export default PaginatedSlider;
